export const animalsActions = {
  fetch: () => ({
    type: 'animals.fetch',
  }),
  fetchSuccess: (payload) => ({
    type: 'animals.success',
    payload,
  }),
  fetchFailure: (payload) => ({
    type: 'animals.failure',
    payload,
  }),

  fetchAnimalKeeping: (payload) => ({
    type: 'animals.fetchanimalKeeping',
    payload,
  }),
  fetchAnimalKeepingSuccess: (payload) => ({
    type: 'animals.animalKeepingsuccess',
    payload,
  }),
  fetchAnimalKeepingFailure: (payload) => ({
    type: 'animals.animalKeepingfailure',
    payload,
  }),
};
